export default __webpack_public_path__ + "static/media/IC00046-community.bca45345.svg";